import { UserAttributesClient } from 'frontend-preferences-client';
const userAttributesClient = UserAttributesClient.forCaller('recording-review-components-lib');
export const UserAttributesIds = {
  CALLS_WITH_TRANSCRIPT_FEEDBACK: 'CALLS_WITH_TRANSCRIPT_FEEDBACK'
};
const fetchCallsWithTranscriptFeedback = () => {
  return userAttributesClient.fetch(UserAttributesIds.CALLS_WITH_TRANSCRIPT_FEEDBACK, '[]').then(res => {
    if (!res) return [];
    const parsedRes = JSON.parse(res);
    return Array.isArray(parsedRes) ? parsedRes : [];
  });
};
export const checkCallWithTranscriptFeedback = callId => {
  return fetchCallsWithTranscriptFeedback().then(res => res.includes(callId)).catch(() => false);
};
export const setCallWithTranscriptFeedback = async callId => {
  try {
    const callsWithFeedbackArr = await fetchCallsWithTranscriptFeedback();
    callsWithFeedbackArr.push(callId);
    await userAttributesClient.write(UserAttributesIds.CALLS_WITH_TRANSCRIPT_FEEDBACK, JSON.stringify(callsWithFeedbackArr));
    return true;
  } catch (e) {
    return false;
  }
};